<template>
    <v-flex xs12 sm12 d-block class="card-dados card-dados__mobile">
        <h3 class="card-dados__titulo mb-0">Notificar Fornecedores por Linha de Fornecimento</h3>

        <v-data-table :headers="colunas" :items="value"
                      no-data-text="Não há linhas de fornecimento adicionadas"
                      class="az-table-list tabela-linha">
            <template slot="items" slot-scope="props">
                <td>
                    {{props.item.linhaFornecimentoCodigo}} - {{props.item.linhaFornecimentoDescricao}}
                </td>
            </template>
        </v-data-table>
    </v-flex>
</template>

<script>
export default {
    name: 'PainelLinhaFornecimentoVisualizacao',
    props: {
        value: {
            required: true
        }
    },
    data() {
        return {
            colunas: [
                {
                    text: 'Linha de Fornecimento',
                    value: 'linhaFornecimentoCodigo',
                    sortable: true,
                    align: 'left',
                    width: '100%',
                    class: 'primary--text'
                }
            ]
        }
    }
}
</script>

<style scoped lang="stylus">
    .tabela-linha
        padding 16px

    @media (max-width 720px)
        .tabela-linha
            padding 0

            td:nth-of-type(1):before
                content "Linha de Fornecimento:"
</style>